var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnywhereOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.537 13.294a1.64 1.64 0 00-.859-.486l-1.376-6.956c.377-.413.607-.97.603-1.58-.01-1.265-1.013-2.282-2.241-2.272-1.229.01-2.217 1.042-2.207 2.306a2.32 2.32 0 00.508 1.438l-7.293 11.95a2.067 2.067 0 00-.56-.074c-1.175.01-2.12.997-2.112 2.206.01 1.21.97 2.183 2.145 2.174 1.175-.01 2.12-.997 2.112-2.207a2.218 2.218 0 00-.508-1.402l7.272-11.917a2.163 2.163 0 001.115.054l1.292 6.53a1.65 1.65 0 00-.23.184 1.726 1.726 0 00-.043 2.398c.634.676 1.681.7 2.339.052a1.726 1.726 0 00.043-2.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnywhereOutline);
export default __webpack_public_path__ + "17c89b001e6523a00ea7dcf58a3cf9b9.svg";
export { ForwardRef as ReactComponent };